export const REPORT_RETRIEVED = "REPORT_RETRIEVED";
export const PRINT_CLEAR_CASH = "PRINT_CLEAR_CASH";
export const EXIT_CLEAR_CASH = "EXIT_CLEAR_CASH";
export const ERROR_REPORT = "ERROR_REPORT";